/* DERWAL Blade Organizer: 3D animation for the product page (stage from sections/derwal-product.liquid). */
(function () {
  var stage = document.getElementById('stage');
  if (!stage || !stage.getAttribute('data-model')) return;
  // texts follow the page language (English by default, Dutch on /nl)
  var NL = /^nl/i.test(document.documentElement.lang || '');
  function L(en, nl) { return NL ? nl : en; }
  // dimension overlay: created here, the product section only provides the stage
  if (!document.getElementById('dw-org-style')) {
    var st = document.createElement('style'); st.id = 'dw-org-style';
    st.textContent = '.dw .stage .dims{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible}' +
      '.dw .stage .dim-tag{position:absolute;left:0;top:0;pointer-events:none;white-space:nowrap;padding:3px 8px;font-family:Montserrat,"Helvetica Neue",Arial,sans-serif;font-weight:600;font-size:clamp(10px,1.15vw,13px);letter-spacing:.08em;color:#15171B;background:rgba(247,247,245,.82);border:1px solid rgba(20,21,24,.14);opacity:0}';
    document.head.appendChild(st);
  }
  var dimsSvgEl = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); dimsSvgEl.setAttribute('class', 'dims'); dimsSvgEl.id = 'dims'; dimsSvgEl.setAttribute('aria-hidden', 'true');
  var dimTagsDiv = document.createElement('div'); dimTagsDiv.id = 'dimTags';
  var coAnchor = document.getElementById('co');
  stage.insertBefore(dimsSvgEl, coAnchor); stage.insertBefore(dimTagsDiv, coAnchor);
  var cv = document.getElementById('cv');
  var statusEl = document.getElementById('status');
  var labelEl = document.getElementById('colorLabel');
  var captionEl = document.getElementById('caption');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!window.THREE) { statusEl.textContent = L('3D could not be loaded in this browser.', '3D kon niet worden geladen in deze browser.'); return; }

  var COLORS = [{ name: 'Black', hex: 0x1B1C1E }, { name: 'Green', hex: 0x1F4A40 }, { name: 'Blue', hex: 0x22385A }];
  function lin(hex) { return new THREE.Color(hex).convertSRGBToLinear(); }

  var renderer;
  try { renderer = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: true }); }
  catch (e) { statusEl.textContent = L('3D is not supported in this browser.', '3D wordt niet ondersteund in deze browser.'); return; }
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 0.82;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  var scene = new THREE.Scene();
  var pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
  var camera = new THREE.PerspectiveCamera(26, 16 / 9, 20, 2000);

  var key = new THREE.DirectionalLight(0xffffff, 1.25);
  key.position.set(-140, 260, 180); key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  key.shadow.camera.left = -190; key.shadow.camera.right = 190; key.shadow.camera.top = 190; key.shadow.camera.bottom = -190;
  key.shadow.camera.near = 10; key.shadow.camera.far = 800; key.shadow.radius = 6; key.shadow.bias = -0.0004;
  scene.add(key);
  var rim = new THREE.DirectionalLight(0xffffff, 0.6); rim.position.set(180, 140, -200); scene.add(rim);
  scene.add(new THREE.HemisphereLight(0xffffff, 0xd8d8d4, 0.22));
  var ground = new THREE.Mesh(new THREE.PlaneGeometry(3000, 3000), new THREE.ShadowMaterial({ opacity: 0.18 }));
  ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

  // Model frame (mm), measured from the part: 96 (x) × 28.8 (y) × 123 (z), centred on x and z, bottom on y = 0.
  // 30 compartments, 3 across (x centres -31, 0, 31) × 10 along (z centres -54 … 54, pitch 12),
  // each 30 (x) × 11 (z) inside, floor at y = 0.8, open top at y = 28.8, walls 1 mm. Logo inlaid in the bottom face.
  var W = 96, H = 28.8, D = 123, FLOOR = 0.8, SX = 30, SZ = 11;
  var COLS = [-31, 0, 31], ROWS = []; for (var r = 0; r < 10; r++) ROWS.push(-54 + r * 12);

  var PIVOT = 14;
  var turn = new THREE.Group(); scene.add(turn);
  var flip = new THREE.Group(); flip.position.y = PIVOT; turn.add(flip);
  var model = new THREE.Group(); model.position.set(0, -PIVOT, 0); model.visible = false; flip.add(model);
  var bodyMat = new THREE.MeshStandardMaterial({ color: lin(COLORS[0].hex), roughness: 0.78, metalness: 0, envMapIntensity: 0.45 });
  var logoMat = new THREE.MeshStandardMaterial({ color: lin(0xEDEDEA), roughness: 0.6, envMapIntensity: 0.6 });

  // ----- wrapped blades: plain made-up wrappers in a handful of "brand" colours, one brand per compartment -----
  // each "brand": paper tint, ink colour and a print style, so the compartments read as different brands
  var BRANDS = [
    { paper: '#F4F1E8', ink: '#2B3F7E', style: 'band' },
    { paper: '#F6E7E2', ink: '#A32A2A', style: 'stripes' },
    { paper: '#E3EEE6', ink: '#1F5E4A', style: 'band' },
    { paper: '#F3EBCF', ink: '#2A2A2E', style: 'dots' },
    { paper: '#E1E8F2', ink: '#1E3F73', style: 'stripes' },
    { paper: '#EEE6F0', ink: '#5B3A7A', style: 'band' },
    { paper: '#F5F5F2', ink: '#C0701A', style: 'dots' }
  ];
  function drawPaper(c, br) {
    var w = c.width, h = c.height, g = c.getContext('2d');
    g.fillStyle = br.paper; g.fillRect(0, 0, w, h);
    for (var i = 0; i < 4000; i++) { g.fillStyle = Math.random() < 0.5 ? 'rgba(120,110,95,0.05)' : 'rgba(255,255,255,0.35)'; g.fillRect(Math.random() * w, Math.random() * h, 1.5, 1.5); }
    g.fillStyle = br.ink;
    if (br.style === 'band') {
      g.fillRect(0, h * 0.1, w, h * 0.2);
      g.fillStyle = br.paper; g.fillRect(w * 0.2, h * 0.16, w * 0.6, h * 0.035); g.fillRect(w * 0.3, h * 0.22, w * 0.4, h * 0.025);
    } else if (br.style === 'stripes') {
      for (var y = 0; y < h; y += 56) g.fillRect(0, y, w, 18);
      g.fillRect(w * 0.2, h * 0.12, w * 0.6, h * 0.12);
    } else {
      for (var yy = 24; yy < h; yy += 40) for (var xx = (yy / 40 % 2) * 20 + 16; xx < w; xx += 40) { g.beginPath(); g.arc(xx, yy, 7, 0, Math.PI * 2); g.fill(); }
      g.fillStyle = br.paper; g.fillRect(w * 0.12, h * 0.1, w * 0.76, h * 0.16);
      g.fillStyle = br.ink; g.fillRect(w * 0.22, h * 0.15, w * 0.56, h * 0.06);
    }
    g.strokeStyle = 'rgba(40,35,30,0.25)'; g.lineWidth = 2;
    g.beginPath(); g.moveTo(0, 30); g.lineTo(w, 30); g.moveTo(0, h - 30); g.lineTo(w, h - 30); g.stroke();
  }
  var paperMats = BRANDS.map(function (br) {
    var c = document.createElement('canvas'); c.width = 256; c.height = 480; drawPaper(c, br);
    var tex = new THREE.CanvasTexture(c); tex.encoding = THREE.sRGBEncoding; tex.anisotropy = 8;
    return new THREE.MeshStandardMaterial({ map: tex, roughness: 0.92 });
  });
  var edgeMat = new THREE.MeshStandardMaterial({ color: lin(0xEDEAE2), roughness: 0.92 });
  // a wrapped blade standing on its long edge: 23 wide (along the compartment), 43.5 tall, 0.4 thick
  var BW = 23, BH = 43.5, BT = 0.4;
  var paperGeo = new THREE.BoxGeometry(BW, BH, BT);

  // the generic 5-blade pack (card tuck box): 25 × 46 × 8 mm
  function drawBox(c) {
    var g = c.getContext('2d'), w = c.width, h = c.height;
    g.fillStyle = '#E9E3D6'; g.fillRect(0, 0, w, h);
    g.fillStyle = '#7A2E2A'; g.fillRect(0, 0, w, h * 0.22); g.fillRect(0, h * 0.78, w, h * 0.22);
    g.fillStyle = '#7A2E2A'; g.textAlign = 'center';
    g.font = '600 46px Montserrat, Arial'; g.fillText('5', w / 2, h * 0.47);
    g.font = '600 15px Montserrat, Arial'; g.fillText('DOUBLE EDGE', w / 2, h * 0.56); g.fillText('BLADES', w / 2, h * 0.62);
    g.strokeStyle = 'rgba(0,0,0,0.25)'; g.lineWidth = 2; g.strokeRect(1, 1, w - 2, h - 2);
  }
  var bc = document.createElement('canvas'); bc.width = 160; bc.height = 300; drawBox(bc);
  var boxTex = new THREE.CanvasTexture(bc); boxTex.encoding = THREE.sRGBEncoding; boxTex.anisotropy = 8;
  var boxFace = new THREE.MeshStandardMaterial({ map: boxTex, roughness: 0.85 });
  var boxSide = new THREE.MeshStandardMaterial({ color: lin(0xE9E3D6), roughness: 0.85 });
  var boxEnd = new THREE.MeshStandardMaterial({ color: lin(0x7A2E2A), roughness: 0.85 });
  var PACK = { x: 25, y: 46, z: 8 };
  var packMesh = new THREE.Mesh(new THREE.BoxGeometry(PACK.x, PACK.y, PACK.z), [boxSide, boxSide, boxEnd, boxEnd, boxFace, boxFace]);
  packMesh.castShadow = true; packMesh.receiveShadow = true;
  var PACK_SLOT = { col: 2, row: 7 };

  // fill every compartment: 5 loose blades each (150 in total), except one that takes the 5-blade pack
  var blades = [], slots = [], slotIdx = 0;
  ROWS.forEach(function (z, ri) {
    COLS.forEach(function (x, ci) {
      var order = slotIdx++;
      if (ci === PACK_SLOT.col && ri === PACK_SLOT.row) { slots.push({ x: x, z: z, order: order, pack: true }); return; }
      var pm = paperMats[(ri * 2 + ci * 3) % paperMats.length], mat = [edgeMat, edgeMat, edgeMat, edgeMat, pm, pm];
      for (var k = 0; k < 5; k++) {
        var m = new THREE.Mesh(paperGeo, mat); m.castShadow = true; m.receiveShadow = true;
        // the stack of five leans gently against one wall of the 11 mm compartment
        var lean = 0.05 + 0.015 * ((ri + ci + k) % 3);
        m.userData = { x: x + ((k * 7 + ri * 3 + ci) % 5 - 2) * 0.6, y: FLOOR + BH / 2 * Math.cos(lean), z: z - 3.6 + k * 1.15 + Math.sin(lean) * BH / 2, lean: lean, order: order, k: k };
        model.add(m); blades.push(m);
      }
      slots.push({ x: x, z: z, order: order });
    });
  });
  var packSlot = slots.filter(function (s) { return s.pack; })[0];
  packMesh.userData = { x: packSlot.x, y: FLOOR + PACK.y / 2, z: packSlot.z };
  model.add(packMesh);

  // outline of the measured compartment's opening (the compartment at the front-left corner)
  var slotRef = { x: COLS[0], z: ROWS[9] };
  var hlPts = [[-SX / 2, -SZ / 2], [SX / 2, -SZ / 2], [SX / 2, SZ / 2], [-SX / 2, SZ / 2], [-SX / 2, -SZ / 2]].map(function (q) { return new THREE.Vector3(slotRef.x + q[0], H + 0.15, slotRef.z + q[1]); });
  var hl = new THREE.Line(new THREE.BufferGeometry().setFromPoints(hlPts), new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0 }));
  model.add(hl);

  // ---------- timeline ----------
  var BASE = -0.55;
  var CYCLE = 24.0, FLIP = -2.0, START = 6.0;   // the timeline starts at 6 s: the old tip-over to show the logo is left out
  var colorIdx = 0, fromC = lin(COLORS[0].hex), toC = lin(COLORS[0].hex), mixK = 1, cycleOn = !reduce;
  var t = 0, last = null, loaded = false, lastCyc = -1;
  var userYaw = 0, dragging = false, dragX = 0, idle = 0;
  function ease(x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function clamp(x) { return Math.max(0, Math.min(1, x)); }
  function seg(x, a, b) { return clamp((x - a) / (b - a)); }

  function setColor(i, instant) {
    colorIdx = i; fromC = bodyMat.color.clone(); toC = lin(COLORS[i].hex); mixK = instant ? 1 : 0;
    if (instant) bodyMat.color.copy(toC);
    var sw = document.querySelector('#swatches button[data-c="' + i + '"]');
    if (labelEl) labelEl.textContent = (sw && sw.getAttribute('data-name')) || COLORS[i].name;
    document.querySelectorAll('#swatches button').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.c === i)); });
  }
  var lastCap = null;
  function caption(txt) { if (txt !== lastCap) { lastCap = txt; captionEl.textContent = txt; } }

  // ----- dimension lines: drawn in the stage's SVG overlay from points on the model -----
  var dimSvg = document.getElementById('dims'), dimTagsEl = document.getElementById('dimTags');
  var SVGNS = 'http://www.w3.org/2000/svg';
  function V(x, y, z) { return new THREE.Vector3(x, y, z); }
  // each dimension: a, b = the two measured points; o = offset direction (model space) for the dimension line
  var DIMS = {
    outer: [
      { a: V(-W / 2, 0, D / 2), b: V(W / 2, 0, D / 2), o: V(0, 0, 1), off: 14, text: '96 mm' },
      { a: V(W / 2, 0, D / 2), b: V(W / 2, 0, -D / 2), o: V(1, 0, 0), off: 14, text: '123 mm' },
      { a: V(-W / 2, 0, D / 2), b: V(-W / 2, H, D / 2), o: V(-1, 0, 0), off: 12, text: '28.8 mm' }
    ],
    slot: [
      { a: V(slotRef.x - SX / 2, H, slotRef.z - SZ / 2), b: V(slotRef.x + SX / 2, H, slotRef.z - SZ / 2), o: V(0, 1, 0), off: 10, text: '30 mm' },
      { a: V(slotRef.x - SX / 2, H, slotRef.z + SZ / 2), b: V(slotRef.x - SX / 2, H, slotRef.z - SZ / 2), o: V(-1, 0, 0), off: 14, text: '11 mm' },
      { a: V(slotRef.x + SX / 2, FLOOR, D / 2), b: V(slotRef.x + SX / 2, H, D / 2), o: V(1, 0, 0), off: 7, text: L('28 mm deep', '28 mm diep') }
    ]
  };
  var dimEls = [];
  Object.keys(DIMS).forEach(function (grp) {
    DIMS[grp].forEach(function (d) {
      var g = document.createElementNS(SVGNS, 'g'); g.setAttribute('stroke', '#141518'); g.setAttribute('stroke-width', '1.2'); g.style.opacity = 0;
      var ls = []; for (var i = 0; i < 5; i++) { var l = document.createElementNS(SVGNS, 'line'); g.appendChild(l); ls.push(l); }
      ls[1].setAttribute('stroke-dasharray', '3 3'); ls[2].setAttribute('stroke-dasharray', '3 3'); ls[1].setAttribute('stroke-width', '0.8'); ls[2].setAttribute('stroke-width', '0.8');
      dimSvg.appendChild(g);
      var tag = document.createElement('div'); tag.className = 'dim-tag'; tag.textContent = d.text; dimTagsEl.appendChild(tag);
      dimEls.push({ grp: grp, d: d, g: g, ls: ls, tag: tag });
    });
  });
  // the compartment seen "through" the front wall: a dashed outline on the front face, floor to rim
  var ghost = document.createElementNS(SVGNS, 'polygon');
  ghost.setAttribute('fill', 'rgba(255,255,255,0.08)'); ghost.setAttribute('stroke', '#ffffff'); ghost.setAttribute('stroke-width', '1.2'); ghost.setAttribute('stroke-dasharray', '4 3'); ghost.style.opacity = 0;
  dimSvg.appendChild(ghost);
  var GHOST = [V(slotRef.x - SX / 2, FLOOR, D / 2), V(slotRef.x + SX / 2, FLOOR, D / 2), V(slotRef.x + SX / 2, H, D / 2), V(slotRef.x - SX / 2, H, D / 2)];
  var pv = new THREE.Vector3();
  function scr(p, r) { pv.copy(p); model.localToWorld(pv); pv.project(camera); return [(pv.x + 1) / 2 * r.width, (1 - pv.y) / 2 * r.height]; }
  function updateDims(alpha) {
    var r = stage.getBoundingClientRect();
    scene.updateMatrixWorld();
    var ga = alpha.slot || 0; ghost.style.opacity = ga;
    if (ga > 0) ghost.setAttribute('points', GHOST.map(function (q) { return scr(q, r).join(','); }).join(' '));
    dimEls.forEach(function (e) {
      var a = alpha[e.grp] || 0;
      e.g.style.opacity = a; e.tag.style.opacity = a;
      if (a <= 0) return;
      var d = e.d, oa = d.a.clone().addScaledVector(d.o, d.off), ob = d.b.clone().addScaledVector(d.o, d.off);
      var A = scr(d.a, r), B = scr(d.b, r), OA = scr(oa, r), OB = scr(ob, r);
      // main line, two extension lines, two end ticks (perpendicular on screen)
      function set(l, p, q) { l.setAttribute('x1', p[0]); l.setAttribute('y1', p[1]); l.setAttribute('x2', q[0]); l.setAttribute('y2', q[1]); }
      set(e.ls[0], OA, OB); set(e.ls[1], A, OA); set(e.ls[2], B, OB);
      var dx = OB[0] - OA[0], dy = OB[1] - OA[1], len = Math.hypot(dx, dy) || 1, nx = -dy / len * 5, ny = dx / len * 5;
      set(e.ls[3], [OA[0] - nx, OA[1] - ny], [OA[0] + nx, OA[1] + ny]);
      set(e.ls[4], [OB[0] - nx, OB[1] - ny], [OB[0] + nx, OB[1] + ny]);
      // label sits on the dimension line, pushed a little further out
      var mx = (OA[0] + OB[0]) / 2, my = (OA[1] + OB[1]) / 2, ex = (OA[0] + OB[0]) / 2 - (A[0] + B[0]) / 2, ey = (OA[1] + OB[1]) / 2 - (A[1] + B[1]) / 2, el = Math.hypot(ex, ey) || 1;
      e.tag.style.transform = 'translate(' + (mx + ex / el * 12) + 'px,' + (my + ey / el * 12) + 'px) translate(-50%,-50%)';
    });
  }

  // callouts: dot on the model, a line, and a label in a subtle box
  var coSvg = document.getElementById('co'), coLine = document.getElementById('coLine'), coDot = document.getElementById('coDot');
  var coText = document.getElementById('coText'), coTitle = document.getElementById('coTitle'), coSub = document.getElementById('coSub');
  var CALLOUTS = {
    1: { at: V(0, 0, -6), title: L('DERWAL logo', 'DERWAL-logo'), sub: L('Inlaid in the base', 'Ingelegd in de onderkant') },
    2: { at: V(COLS[1], FLOOR + BH + 0.5, ROWS[4]), title: L('30 compartments', '30 vakjes'), sub: L('About 5 blades each, 150 in total', 'Elk ongeveer 5 mesjes, 150 in totaal') },
    3: { at: V(packSlot.x, FLOOR + PACK.y + 0.3, packSlot.z), title: L('Fits a 5-blade pack', 'Past een doosje van 5'), sub: L('Drop the whole box in', 'Zet het hele doosje erin') }
  };
  var lastCo = 0, coV = new THREE.Vector3();
  function updateCallout(id, a) {
    if (!id || a <= 0) { coSvg.style.opacity = 0; coText.style.opacity = 0; return; }
    var d = CALLOUTS[id];
    if (id !== lastCo) { lastCo = id; coTitle.textContent = d.title; coSub.textContent = d.sub; }
    scene.updateMatrixWorld();
    coV.copy(d.at); model.localToWorld(coV); coV.project(camera);
    var r = stage.getBoundingClientRect(), Wd = r.width, Hd = r.height;
    var sx = (coV.x + 1) / 2 * Wd, sy = (1 - coV.y) / 2 * Hd;
    var tw = coText.offsetWidth || 240, th = coText.offsetHeight || 50, gap = Math.max(50, Wd * 0.08);
    var right = sx + gap + tw < Wd - 16;
    var lx = right ? sx + gap : sx - gap, ly = Math.max(th / 2 + 8, sy - Math.min(48, Hd * 0.08));
    coDot.setAttribute('cx', sx); coDot.setAttribute('cy', sy);
    coLine.setAttribute('x1', sx); coLine.setAttribute('y1', sy);
    coLine.setAttribute('x2', lx); coLine.setAttribute('y2', ly);
    coText.style.transform = 'translate(' + (right ? lx : lx - tw) + 'px,' + ly + 'px) translateY(-50%)';
    coSvg.style.opacity = a; coText.style.opacity = a;
  }

  var camDist = 400, camLift = -1, camFocus = 0;
  // lift: higher view while the organizer is tipped over; focus: lean in towards the measured compartment
  function placeCamera(lift, focus) {
    var elev = (30 + 4 * lift + 8 * focus) * Math.PI / 180, ty = 12 + 16 * lift;
    var dist = camDist * (1 - 0.45 * focus);
    var fx = 0, fz = 0;
    if (focus > 0) {
      var p = V(slotRef.x, H, slotRef.z); model.localToWorld(p);
      fx = p.x * focus; fz = p.z * focus;
    }
    camera.position.set(fx, ty + Math.sin(elev) * dist, fz + Math.cos(elev) * dist);
    camera.lookAt(fx, ty, fz);
  }
  function resize() {
    var r = stage.getBoundingClientRect();
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(r.width, r.height, false);
    camera.aspect = r.width / r.height;
    camDist = r.width / r.height < 1.2 ? 600 : 400;
    camera.updateProjectionMatrix();
    placeCamera(Math.max(0, camLift), camFocus);
  }

  function pose(time) {
    var p = { yaw: BASE, flipK: 0, fill: 1, out: 0, co: 0, coA: 0, dims: { outer: 0, slot: 0 }, focus: 0, hl: 0 };
    if (reduce) return p;
    var c = time % CYCLE + START;
    // 2) outer size measured out
    p.dims.outer = Math.min(seg(c, 7.4, 7.9), 1 - seg(c, 11.0, 11.5));
    // 3) the camera leans in on one compartment and measures it
    p.focus = ease(seg(c, 11.3, 12.5)) * (1 - ease(seg(c, 16.0, 17.2)));
    p.hl = Math.min(seg(c, 12.3, 12.7), 1 - seg(c, 15.6, 16.0));
    p.dims.slot = Math.min(seg(c, 12.5, 13.0), 1 - seg(c, 15.6, 16.0));
    // 4) blades drop into all 30 compartments in a wave, the 5-blade pack into one of them
    p.fill = seg(c, 17.4, 20.6);
    if (c >= 20.8 && c < 23.0) { p.co = 2; p.coA = Math.min(seg(c, 20.8, 21.15), 1 - seg(c, 22.65, 23.0)); }
    if (c >= 23.0 && c < 25.0) { p.co = 3; p.coA = Math.min(seg(c, 23.0, 23.35), 1 - seg(c, 24.65, 25.0)); }
    // 5) one full turn, filled
    if (c >= 25.0 && c < 28.6) p.yaw = BASE + Math.PI * 2 * ease(seg(c, 25.0, 28.6));
    // 6) everything is lifted out again before the next round
    p.out = ease(seg(c, 28.6, 29.6));
    if (c < 7.2) caption('');
    else if (c < 11.3) caption(L('Outer size', 'Buitenmaat'));
    else if (c < 17.2) caption(L('One compartment', 'Eén vakje'));
    else if (c < 20.8) caption(L('Sort your blades by brand', 'Sorteer je mesjes per merk'));
    else if (c < 25.0) caption('');
    else caption('');
    if (cycleOn) { var cyc = Math.floor(time / CYCLE); if (c >= 29.7 && lastCyc !== cyc) { lastCyc = cyc; setColor((colorIdx + 1) % COLORS.length); } }
    return p;
  }

  // per-compartment drop: each compartment starts a little after the previous one, its blades one after another
  function dropK(fill, order, k) {
    var start = order / 30 * 0.72 + k * 0.012;
    return ease(clamp((fill - start) / 0.22));
  }
  function frame(now) {
    if (stage.dataset.paused === '1') { last = now; requestAnimationFrame(frame); return; }
    var dt = last == null ? 0 : Math.min(0.05, (now - last) / 1000); last = now;
    if (loaded) {
      t += dt;
      var p = pose(t);
      if (!dragging) { idle += dt; if (idle > 2.5) userYaw *= Math.pow(0.15, dt); }
      var sway = reduce ? 0 : 0.05 * Math.sin(t * 0.7);
      turn.rotation.y = p.yaw + sway + userYaw;
      flip.rotation.x = FLIP * p.flipK;
      flip.position.y = PIVOT + 30 * Math.sin(Math.PI / 2 * Math.min(1, p.flipK * 1.6));
      if (p.flipK !== camLift || p.focus !== camFocus) { camLift = p.flipK; camFocus = p.focus; placeCamera(camLift, camFocus); }
      var up = p.out;
      blades.forEach(function (m) {
        var u = m.userData, k = dropK(p.fill, u.order, u.k), fall = 1 - k;
        m.visible = k > 0 && up < 1;
        m.position.set(u.x, u.y + 60 * fall * fall + 110 * up * up, u.z);
        m.rotation.set(-u.lean - 0.3 * fall, 0.4 * fall, 0);
      });
      var pk = dropK(p.fill, packSlot.order, 0), pf = 1 - pk;
      packMesh.visible = pk > 0 && up < 1;
      packMesh.position.set(packMesh.userData.x, packMesh.userData.y + 70 * pf * pf + 110 * up * up, packMesh.userData.z);
      packMesh.rotation.set(-0.3 * pf, 0.5 * pf, 0);
      hl.material.opacity = p.hl; hl.visible = p.hl > 0;
      updateDims(p.dims);
      updateCallout(p.co, p.coA);
      if (mixK < 1) { mixK = Math.min(1, mixK + dt / 0.8); bodyMat.color.copy(fromC).lerp(toC, ease(mixK)); }
    }
    renderer.render(scene, camera);
    requestAnimationFrame(frame);
  }

  stage.addEventListener('pointerdown', function (e) { dragging = true; dragX = e.clientX; idle = 0; stage.setPointerCapture(e.pointerId); });
  stage.addEventListener('pointermove', function (e) { if (!dragging) return; userYaw += (e.clientX - dragX) * 0.008; dragX = e.clientX; });
  function endDrag() { dragging = false; idle = 0; }
  stage.addEventListener('pointerup', endDrag); stage.addEventListener('pointercancel', endDrag);
  document.querySelectorAll('#swatches button').forEach(function (b) { b.addEventListener('click', function () { setCycle(false); setColor(+b.dataset.c, false); }); });
  // on the product page the swatches pick the variant: the 3D follows the chosen colour and stops cycling
  function setCycle(on) { cycleOn = on; }
  var replayBtn = document.getElementById('replay');
  if (replayBtn) replayBtn.addEventListener('click', function () { t = 0; lastCyc = -1; userYaw = 0; });
  var pre = document.querySelector('#swatches button[aria-pressed="true"]');
  if (pre) setColor(+pre.dataset.c, true);
  if (reduce) setCycle(false);

  if (window.ResizeObserver) new ResizeObserver(resize).observe(stage); else window.addEventListener('resize', resize);
  resize();
  requestAnimationFrame(frame);

  function fail(msg) { statusEl.hidden = false; statusEl.textContent = L('The model could not be loaded', 'Het model kon niet worden geladen') + ' (' + String(msg).slice(0, 120) + ').'; }
  var xhr = new XMLHttpRequest();
  xhr.open('GET', stage.getAttribute('data-model')); xhr.responseType = 'arraybuffer';
  xhr.onprogress = function (ev) { if (ev.total) statusEl.textContent = L('Loading model… ', 'Model laden… ') + Math.round(ev.loaded / ev.total * 100) + '%'; };
  xhr.onerror = function () { fail('network error'); };
  xhr.ontimeout = function () { fail('timed out'); }; xhr.timeout = 60000;
  xhr.onload = function () {
    if (xhr.status && xhr.status !== 200) { fail('HTTP ' + xhr.status); return; }
    var glb;
    glb = xhr.response;
    new THREE.GLTFLoader().parse(glb, '', function (gltf) {
      gltf.scene.traverse(function (o) {
        if (!o.isMesh) return;
        // the part comes without normals: split it per face so the flat faces and sharp edges shade crisply
        o.geometry = o.geometry.index ? o.geometry.toNonIndexed() : o.geometry; o.geometry.computeVertexNormals();
        var name = o.name || (o.parent && o.parent.name) || '';
        if (/Logo/.test(name)) o.material = logoMat;
        else { o.material = bodyMat; o.castShadow = true; o.receiveShadow = true; }
      });
      model.add(gltf.scene);
      statusEl.hidden = true; loaded = true; model.visible = true;
    }, function (e) { fail(e && e.message ? e.message : 'parse error'); });
  };
  xhr.send();
})();
